// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrdersLine_ordersLine__teFzn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
}
@media (min-width: 640px) {
  .OrdersLine_ordersLine__teFzn {
    margin-top: 16px;
  }
}
@media (min-width: 1200px) {
  .OrdersLine_ordersLine__teFzn {
    display: block;
    margin-top: 0;
  }
}

.OrdersLine_item__GMJ1t {
  padding: 4px 12px;
  font-size: 16px;
  line-height: 16px;
  font-weight: 600;
  border-radius: 12px;
  height: 50px;
  width: calc(50% - 4px);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  background: var(--white);
  border: 1px solid #EFF3F5;
  text-align: center;
  transition: var(--transition);
  transition-property: box-shadow;
}
@media (hover: hover) {
  .OrdersLine_item__GMJ1t:hover {
    box-shadow: -8px 0px 24px 0px rgba(0, 0, 0, 0.2);
  }
}
@media (min-width: 640px) {
  .OrdersLine_item__GMJ1t {
    height: 64px;
    font-size: 18px;
    line-height: 100%;
  }
}
@media (min-width: 1200px) {
  .OrdersLine_item__GMJ1t {
    width: 100%;
    height: auto;
    text-align: left;
    justify-content: flex-start;
    font-weight: normal;
    background: var(--white);
    box-shadow: -8px 0px 24px 0px rgba(0, 0, 0, 0.0901960784);
    padding: 16px;
    margin-bottom: 16px;
  }
}
.OrdersLine_item__txtWrap__6\\+SuA {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
}
@media (min-width: 640px) {
  .OrdersLine_item__txtWrap__6\\+SuA {
    gap: 8px;
    font-size: 18px;
  }
}
@media (min-width: 1200px) {
  .OrdersLine_item__txtWrap__6\\+SuA {
    display: block;
    font-weight: 600;
    font-size: var(--fz-lg);
    line-height: var(--lh-lg);
  }
}
.OrdersLine_item__txt--mob__pW7qn {
  text-transform: lowercase;
}
.OrdersLine_item__txt--desktop__Knzw0 {
  display: none;
}
@media (min-width: 1200px) {
  .OrdersLine_item__txt--desktop__Knzw0 {
    display: inline;
  }
}
.OrdersLine_item__activeCount__Q-HPs {
  font-size: var(--fz-md);
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (min-width: 640px) {
  .OrdersLine_item__activeCount__Q-HPs {
    font-size: 18px;
  }
}
@media (min-width: 1200px) {
  .OrdersLine_item__activeCount__Q-HPs {
    color: inherit;
    background: none;
    display: inline;
    font-weight: inherit;
    font-size: inherit;
    line-height: inherit;
    margin-right: 4px;
  }
}
.OrdersLine_item__txtDescr__rn2tA {
  display: none;
}
@media (min-width: 1200px) {
  .OrdersLine_item__txtDescr__rn2tA {
    display: block;
    color: #7A808B;
    font-size: var(--fz-sm);
    line-height: var(--lh-sm);
  }
}
.OrdersLine_item__no-rev__quSGo {
  position: absolute;
  top: -4px;
  right: -4px;
  padding: 4px;
  width: 20px;
  height: 20px;
  font-size: 11px;
  color: var(--white);
  line-height: 100%;
  background-color: red;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 0 3px var(--white);
}
@media (min-width: 640px) {
  .OrdersLine_item__no-rev__quSGo {
    font-size: 16px;
    width: 26px;
    height: 26px;
  }
}
@media (min-width: 1200px) {
  .OrdersLine_item__no-rev__quSGo {
    box-shadow: 0 0 0 3px #FAFAFA;
    font-weight: 600;
    width: 20px;
    height: 20px;
    font-size: 11px;
    padding: 0;
  }
}
.OrdersLine_item__icon__qrdpm {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 100%;
  color: #4F4F4F;
  margin-right: 12px;
  position: absolute;
  left: 13px;
}
@media (min-width: 640px) {
  .OrdersLine_item__icon__qrdpm {
    width: 40px;
    height: 40px;
  }
}
@media (min-width: 1200px) {
  .OrdersLine_item__icon__qrdpm {
    background-color: #FAFAFA;
    position: initial;
  }
}
.OrdersLine_item__icon__qrdpm svg {
  max-height: 18px;
}
@media (min-width: 640px) {
  .OrdersLine_item__icon__qrdpm svg {
    max-height: 24px;
    height: 100%;
    width: 100%;
  }
}
@media (min-width: 1200px) {
  .OrdersLine_item__icon__qrdpm svg {
    height: auto;
    width: auto;
  }
}
.OrdersLine_item__icon--red__xmrvm, .OrdersLine_item__icon--yellow__7dKhg {
  color: var(--white);
}
.OrdersLine_item__icon--red__xmrvm {
  background-color: #FA8B81;
}
.OrdersLine_item__icon--yellow__7dKhg {
  background-color: #FED45A;
}
.OrdersLine_item__icon--stroke__SgheF svg {
  fill: none;
  stroke: currentColor;
}
.OrdersLine_item--is-active__hDBj- {
  background: var(--accent-color);
  color: var(--white);
  text-align: left;
}
@media (min-width: 640px) {
  .OrdersLine_item--is-active__hDBj- {
    width: calc(50% - 8px);
  }
}
@media (min-width: 1200px) {
  .OrdersLine_item--is-active__hDBj- {
    width: auto;
    background: var(--white);
    color: inherit;
    padding: 16px;
  }
}
.OrdersLine_item--is-active__hDBj- .OrdersLine_item__icon__qrdpm {
  background-color: var(--accent-color);
  color: var(--accent-text-color);
}
.OrdersLine_item__GMJ1t:last-child {
  margin-bottom: 0;
}
.OrdersLine_item__GMJ1t:nth-child(n+3) {
  display: none;
}
@media (min-width: 1200px) {
  .OrdersLine_item__GMJ1t:nth-child(n+3) {
    display: flex;
  }
}

.OrdersLine_separator__sGO8R {
  display: none;
  border: none;
  border-top: 1px solid #ECECEC;
  margin: 16px 8px;
}
@media (min-width: 1200px) {
  .OrdersLine_separator__sGO8R {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/OrdersLine/OrdersLine.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AACF;AACE;EANF;IAOI,gBAAA;EAEF;AACF;AAAE;EAVF;IAWI,cAAA;IAGA,aAAA;EACF;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,6BAAA;EACA,+BAAA;AACF;AACE;EACE;IACE,gDAAA;EACJ;AACF;AAEE;EAzBF;IA0BI,YAAA;IACA,eAAA;IACA,iBAAA;EACF;AACF;AACE;EA/BF;IAgCI,WAAA;IACA,YAAA;IACA,gBAAA;IACA,2BAAA;IACA,mBAAA;IACA,wBAAA;IACA,yDAAA;IACA,aAAA;IACA,mBAAA;EAEF;AACF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAEJ;AAAI;EANF;IAOI,QAAA;IACA,eAAA;EAGJ;AACF;AADI;EAXF;IAYI,cAAA;IACA,gBAAA;IACA,uBAAA;IACA,yBAAA;EAIJ;AACF;AAAI;EACE,yBAAA;AAEN;AAAI;EACE,aAAA;AAEN;AAAM;EAHF;IAII,eAAA;EAGN;AACF;AACE;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;AACI;EATF;IAUI,eAAA;EAEJ;AACF;AAAI;EAbF;IAcI,cAAA;IACA,gBAAA;IACA,eAAA;IACA,oBAAA;IACA,kBAAA;IACA,oBAAA;IACA,iBAAA;EAGJ;AACF;AAAE;EACE,aAAA;AAEJ;AAAI;EAHF;IAII,cAAA;IACA,cAAA;IACA,uBAAA;IACA,yBAAA;EAGJ;AACF;AAAE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kCAAA;AAEJ;AAAI;EAjBF;IAkBI,eAAA;IACA,WAAA;IACA,YAAA;EAGJ;AACF;AADI;EAvBF;IAwBI,6BAAA;IACA,gBAAA;IACA,WAAA;IACA,YAAA;IACA,eAAA;IACA,UAAA;EAIJ;AACF;AADE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AAGJ;AADI;EAbF;IAcI,WAAA;IACA,YAAA;EAIJ;AACF;AAFI;EAlBF;IAmBI,yBAAA;IACA,iBAAA;EAKJ;AACF;AAHI;EACE,gBAAA;AAKN;AAHM;EAHF;IAII,gBAAA;IACA,YAAA;IACA,WAAA;EAMN;AACF;AAJM;EATF;IAUI,YAAA;IACA,WAAA;EAON;AACF;AAJI;EAEE,mBAAA;AAKN;AAFI;EACE,yBAAA;AAIN;AADI;EACE,yBAAA;AAGN;AACM;EACE,UAAA;EACA,oBAAA;AACR;AAIE;EACE,+BAAA;EACA,mBAAA;EACA,gBAAA;AAFJ;AAII;EALF;IAMI,sBAAA;EADJ;AACF;AAGI;EATF;IAUI,WAAA;IACA,wBAAA;IACA,cAAA;IACA,aAAA;EAAJ;AACF;AAGM;EACE,qCAAA;EACA,+BAAA;AADR;AAME;EACE,gBAAA;AAJJ;AAOE;EACE,aAAA;AALJ;AAOI;EAHF;IAII,aAAA;EAJJ;AACF;;AAQA;EACE,aAAA;EACA,YAAA;EACA,6BAAA;EACA,gBAAA;AALF;AAOE;EANF;IAOI,cAAA;EAJF;AACF","sourcesContent":[".ordersLine {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 16px;\n\n  @media (min-width: 640px) {\n    margin-top: 16px;\n  }\n\n  @media (min-width: 1200px) {\n    display: block;\n    //position: sticky;\n    //top: calc(var(--header-height) + 25px);\n    margin-top: 0;\n  }\n}\n\n.item {\n  padding: 4px 12px;\n  font-size: 16px;\n  line-height: 16px;\n  font-weight: 600;\n  border-radius: 12px;\n  height: 50px;\n  width: calc(50% - 4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  z-index: 1;\n  background: var(--white);\n  border: 1px solid #EFF3F5;\n  text-align: center;\n  transition: var(--transition);\n  transition-property: box-shadow;\n\n  @media (hover: hover) {\n    &:hover {\n      box-shadow: -8px 0px 24px 0px rgba(0, 0, 0, 0.2);\n    }\n  }\n\n  @media (min-width: 640px) {\n    height: 64px;\n    font-size: 18px;\n    line-height: 100%;\n  }\n\n  @media (min-width: 1200px) {\n    width: 100%;\n    height: auto;\n    text-align: left;\n    justify-content: flex-start;\n    font-weight: normal;\n    background: var(--white);\n    box-shadow: -8px 0px 24px 0px #00000017;\n    padding: 16px;\n    margin-bottom: 16px;\n  }\n\n  &__txtWrap {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 14px;\n\n    @media (min-width: 640px) {\n      gap: 8px;\n      font-size: 18px;\n    }\n\n    @media (min-width: 1200px) {\n      display: block;\n      font-weight: 600;\n      font-size: var(--fz-lg);\n      line-height: var(--lh-lg);\n    }\n  }\n\n  &__txt {\n    &--mob {\n      text-transform: lowercase;\n    }\n    &--desktop {\n      display: none;\n\n      @media (min-width: 1200px) {\n        display: inline;\n      }\n    }\n  }\n\n  &__activeCount {\n    font-size: var(--fz-md);\n    font-style: normal;\n    font-weight: 500;\n    line-height: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    @media (min-width: 640px) {\n      font-size: 18px;\n    }\n\n    @media (min-width: 1200px) {\n      color: inherit;\n      background: none;\n      display: inline;\n      font-weight: inherit;\n      font-size: inherit;\n      line-height: inherit;\n      margin-right: 4px;\n    }\n  }\n\n  &__txtDescr {\n    display: none;\n\n    @media (min-width: 1200px) {\n      display: block;\n      color: #7A808B;\n      font-size: var(--fz-sm);\n      line-height: var(--lh-sm);\n    }\n  }\n\n  &__no-rev {\n    position: absolute;\n    top: -4px;\n    right: -4px;\n    padding: 4px;\n    width: 20px;\n    height: 20px;\n    font-size: 11px;\n    color: var(--white);\n    line-height: 100%;\n    background-color: red;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    box-shadow: 0 0 0 3px var(--white);\n\n    @media (min-width: 640px) {\n      font-size: 16px;\n      width: 26px;\n      height: 26px;\n    }\n\n    @media (min-width: 1200px) {\n      box-shadow: 0 0 0 3px #FAFAFA;\n      font-weight: 600;\n      width: 20px;\n      height: 20px;\n      font-size: 11px;\n      padding: 0;\n    }\n  }\n\n  &__icon {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-shrink: 0;\n    width: 24px;\n    height: 24px;\n    border-radius: 100%;\n    color: #4F4F4F;\n    margin-right: 12px;\n    position: absolute;\n    left: 13px;\n\n    @media (min-width: 640px) {\n      width: 40px;\n      height: 40px;\n    }\n\n    @media (min-width: 1200px) {\n      background-color: #FAFAFA;\n      position: initial;\n    }\n\n    svg {\n      max-height: 18px;\n\n      @media (min-width: 640px) {\n        max-height: 24px;\n        height: 100%;\n        width: 100%;\n      }\n\n      @media (min-width: 1200px) {\n        height: auto;\n        width: auto;\n      }\n    }\n\n    &--red,\n    &--yellow {\n      color: var(--white);\n    }\n\n    &--red {\n      background-color: #FA8B81;\n    }\n\n    &--yellow {\n      background-color: #FED45A;\n    }\n\n    &--stroke {\n      svg {\n        fill: none;\n        stroke: currentColor;\n      }\n    }\n  }\n\n  &--is-active {\n    background: var(--accent-color);\n    color: var(--white);\n    text-align: left;\n\n    @media (min-width: 640px) {\n      width: calc(50% - 8px);\n    }\n\n    @media (min-width: 1200px) {\n      width: auto;\n      background: var(--white);\n      color: inherit;\n      padding: 16px;\n    }\n\n    .item {\n      &__icon {\n        background-color: var(--accent-color);\n        color: var(--accent-text-color);\n      }\n    }\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  &:nth-child(n+3) {\n    display: none;\n\n    @media (min-width: 1200px) {\n      display: flex;\n    }\n  }\n}\n\n.separator {\n  display: none;\n  border: none;\n  border-top: 1px solid #ECECEC;\n  margin: 16px 8px;\n\n  @media (min-width: 1200px) {\n    display: block;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ordersLine": `OrdersLine_ordersLine__teFzn`,
	"item": `OrdersLine_item__GMJ1t`,
	"item__txtWrap": `OrdersLine_item__txtWrap__6+SuA`,
	"item__txt--mob": `OrdersLine_item__txt--mob__pW7qn`,
	"item__txt--desktop": `OrdersLine_item__txt--desktop__Knzw0`,
	"item__activeCount": `OrdersLine_item__activeCount__Q-HPs`,
	"item__txtDescr": `OrdersLine_item__txtDescr__rn2tA`,
	"item__no-rev": `OrdersLine_item__no-rev__quSGo`,
	"item__icon": `OrdersLine_item__icon__qrdpm`,
	"item__icon--red": `OrdersLine_item__icon--red__xmrvm`,
	"item__icon--yellow": `OrdersLine_item__icon--yellow__7dKhg`,
	"item__icon--stroke": `OrdersLine_item__icon--stroke__SgheF`,
	"item--is-active": `OrdersLine_item--is-active__hDBj-`,
	"separator": `OrdersLine_separator__sGO8R`
};
export default ___CSS_LOADER_EXPORT___;
